export type BankIdAction = 'auth' | 'sign';

export const BankIdAction = {
    Auth: 'auth' as BankIdAction,
    Sign: 'sign' as BankIdAction,
};